import localesMessages from "./messages.json";

export const environmentMessages = {
  en: localesMessages.en,
  fr: localesMessages.fr,
};
